export default {"src":"/_next/static/media/Rectangle 4499.30df5304.svg","height":8,"width":8,"blurWidth":0,"blurHeight":0};